import { About } from "./components/About";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { Nav } from "./components/Nav";
import { Projects } from "./components/Projects";
import { Services } from "./components/Services";
import { GlobalStyle } from "./createGlobalStyle";
import Fade from 'react-reveal/Fade';

function App() {
  return (
    <>
      <Header/>
      <Nav/>
      <Fade>
        <About/>
      </Fade>
      <Fade>
        <Services/>
      </Fade>
      <Fade>
        <Footer/>
      </Fade>
      {/* <Projects/> */}
      <GlobalStyle/>
    </>
  );
}

export default App;
